module.exports = __webpack_public_path__ + "img/add.45f21d10.svg";